import { render } from "./DashboardToolbar.vue?vue&type=template&id=1edb4afc&ts=true"
import script from "./DashboardToolbar.vue?vue&type=script&lang=ts"
export * from "./DashboardToolbar.vue?vue&type=script&lang=ts"

import "./DashboardToolbar.vue?vue&type=style&index=0&id=1edb4afc&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__